<template>
  <v-col cols="8" class="pb-0 pt-1">
    <span class="bottom-el blue-grey--text mr-2"> 
      <span v-if="resp.pregunta.vertical">
        {{resp.pregunta.doc_required ? '*' : ''}} Documentos probatorios: 
      </span>
      <span v-else>
        {{resp.pregunta.description_request_file 
          ? resp.pregunta.description_request_file 
          : '*Listado (entidades y dependencias)'}}
      </span>
    </span>
    <v-chip
      small
      v-for="file in resp.files"
      class="mx-2  mt-2"
      close
      text-color="red"
      color="teal lighten-5"
      :close-icon="is_ies && editable ? 'mdi-delete' : ''"
      @click="download(file.doc_respaldo)"
      @click:close="trashFile(file.id, resp.id)"
    >
      <v-avatar left>
        <v-icon color="blue-grey">attachment</v-icon>
      </v-avatar>
      <span class="blue-grey--text">{{file.name.substr(0,40)}}</span>
    </v-chip>
    <span v-if="!resp.files.length > 0 && !editable">
      No hay Archivos adjuntos
    </span>
    <input 
      type="file"
      :id="`files-${resp.id}`"
      style="display:none"
      multiple
      @change="addFiles($event, resp)"
    >
    <v-btn 
      v-if="is_ies && editable"
      small
      class="mt-2"
      outlined
      color="accent"
      @click="indirect_add(resp.id)"
    >
      <v-icon left>attach_file</v-icon> Agregar
    </v-btn>
    <br>
    <span class="body-2 grey--text">
      <span v-if="resp.pregunta.vertical">
        {{resp.pregunta.description_request_file}}
      </span>
      <span v-else-if="is_ies">
        Formato base para listado: 
        <v-btn 
          color="grey lighten-2"
          small
          :outlined="!!resp.files.length"
          @click="download(resp.pregunta.guide_format)"
        >
          Descargar
        </v-btn>
      </span>
    </span>
    <v-dialog
      v-model="dialog_file_trash"
      max-width="350"
    >
      <v-card>
        <v-card-title class="headline">¿De verdad quieres eliminar el archivo?</v-card-title>
        <v-card-text>
          Una vez eliminado no lo podrás recuperar
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_file_trash = false"
          >
            No eliminar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="deleteFile"
          >
            Sí eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_update"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline no-wrap text-center">
          <span v-if="resp.pregunta.doc_required">
            Agrega el Documento probatorio
          </span>
          <span v-else>
            ¿Cómo te gustaría comprobar tu respuesta?
          </span>
        </v-card-title>
        <v-card-text>
          <span v-if="resp.pregunta.doc_required">
            {{resp.pregunta.description_request_file}}
          </span>
          <span v-else>
            Para comprobar la respuesta, debes adjuntar al menos un archivo o escribir en una nota las referencias necesarias
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            @click="close_dialog_update()"
          >
            Cancelar
          </v-btn>
          <v-btn
            v-if="!resp.pregunta.doc_required"
            color="primary"
            text
            @click="close_dialog_update(true)"
          >
            <v-icon color="">comment</v-icon>
            Nota
          </v-btn>
          <v-btn
            color="primary"
            @click="indirect_add(resp.id)"
          >
            <v-icon>attachment</v-icon>
            <span 
              v-if="resp.pregunta.doc_required"
              class="mr-1" 
            >Agregar </span>
            Archivos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-col>

</template>


<script>

import router from "@/router.js";
import { mapState } from "vuex";

export default {
  name: 'AttFiles',
  props:{
    resp:{
      type: Object,
      required: true,
    },
    dialog_update:{
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data(){
    return {
      file_for_delete: undefined,
      dialog_file_trash: false,
    }
  },
  methods:{
    download(url){
      window.open(url, '_blank');
      //window.open("http://165.227.212.99:5000/media/Maximo_documento_normativo.docx", '_blank');
    },
    indirect_add(resp_id){
      document.getElementById(`files-${resp_id}`).click();
    },
    close_dialog_update(open_comment=false){
      this.$emit('update:dialog_update', false)
      if (open_comment) this.$emit('open_comment')
    },
    addFiles(e, resp){
      var files = e.target.files || e.dataTransfer.files;
      for (let file of files) {
        let formData = new FormData();
        let snack_text = this.dialog_update 
          ? 'Se guardó la respuesta con el archivo'
          : 'Se agregó el archivo a la respuesta'
        formData.append("doc_respaldo", file, file.name);
        this.$store
          .dispatch('POST_FILE', {data:formData,
            answer_id:resp.id, snack_text: snack_text})
          .then((data) => {
            this.close_dialog_update();
            this.$emit("saveFromFile");
          })
          .catch(error =>
            console.log(error)
          );
      }
    },
    trashFile(file_id, answer_id){
      if (this.is_ies)
        this.dialog_file_trash = true,
        this.file_for_delete = {file_id:file_id,
            answer_id: answer_id,
            snack_text:"El archivo fue eliminado"}
    },
    deleteFile(){
      //console.log(this.file_for_delete)      
      this.$store
        .dispatch('DELETE_FILE', this.file_for_delete)
        .then((data) => {
          //console.log(data)
        })
        .catch(error =>
          console.log(error)
        );
      this.dialog_file_trash = false;
    },    
  },
  computed:{
    ...mapState({
      is_ies: state => state.is_ies,
      editable: state => state.ies_year_data.register_referance.status.can_ies_change,
    }),
  },  
  mounted(){
    //this.dialog_update =  this.confirm_no_file
  },
  created(){
  }
}
</script>


<style scoped>

.bottom-el{
  vertical-align: bottom;
}
</style>